/* tp-pool-promise.js — 两池承诺文案唯一源(「一台钟」,店主令 2026-07-28:hero 分流条与
   dark-peak 双卡讲同一套时间判断)。
   规则与 tp-delivery-stepper 结账闸同源:配送截单 14:30 / 自提截单 16:00 / 17:00 翻日
   (过点明天按今天待)/ 周日无当日 / 周六 17:00 后周日整体关闭。
   cutoff 运行时优先读 window.TPDeliveryData.CUTOFFS(全站唯一配送数据源,theme.liquid 全站
   加载),读不到才用同值兜底——绝不在消费方另立时间规则。
   用法:元素加 data-tp-pool-line="express|advance" 自动接管其文字并每秒刷新(倒计时);
   消费方:sections/tp-urgency-bar.liquid、sections/tp-dark-peak.liquid、sections/tp-m-choose.liquid(手机首屏急单行)。改承诺文案只改这里。
   细调②(店主 10/8,TP-SYNC-20261006-MOBILE-UX-23,备用主题):新增 data-tp-pool-line="express-cta"——手机首屏急单行一句
   「Order in 2h 13m → delivered tonight 6–10:30 PM」/ 过了截单「Order now → delivered tomorrow 6–10:30 PM」;
   截单、翻日、周日、周六晚规则与 expressLine 同一台钟,时段文字与 expressLine 共用 EVENING,不另写。 */
(function () {
  if (window.TPPoolPromise) return;
  function cutoffs() {
    var d = window.TPDeliveryData && window.TPDeliveryData.CUTOFFS;
    function mins(s, fb) { if (!s) return fb; var p = s.split(':'); return (+p[0]) * 60 + (+p[1]); }
    return { dc: mins(d && d.delivery, 870), pc: mins(d && d.pickup, 960), ro: mins(d && d.middayNextDay, 1020) };
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  var EVENING = '5:30–10:30 PM'; // 当日 / 次日晚间配送时段(桌面 urgency bar 的 expressLine 用)。原值「6–10:30 PM」,2026-10-08 合并 live 时按店主口径与手机统一(TP-SYNC-20261006-MOBILE-UX-23)。
  // 细调④-B(店主 10/8 拍板,TP-SYNC-20261006-MOBILE-UX-23):晚间时段统一「5:30–11:30 PM」,手机与桌面同值。
  // 店主 10/12:11:30 对核心 GTA 太晚,大多数地区 10:30 → 改回「5:30–10:30 PM」;「部分区域到 11:30」只在有地方的位置说(配送页 / 购物车)。
  // 时段变长后 375 宽一行放不下「→ delivered tonight …」(实测要 299px、只有 271px),手机这句去掉 delivered:「Order in 2h 13m → tonight 5:30–11:30 PM」。
  var EVENING_M = '5:30–10:30 PM';
  // 店主 10/12:时段以 tp-delivery-data.js 为唯一真相,上面两个只是表没加载时的兜底
  function eveLabel() { try { return window.TPDeliveryData.WINDOWS.evening.label || EVENING; } catch (e) { return EVENING; } }
  function torontoNow() { // anchor to America/Toronto, never device time (M2 review rule)
    try {
      var p = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Toronto', hour: '2-digit', minute: '2-digit', second: '2-digit', weekday: 'short', hour12: false }).formatToParts(new Date());
      var g = function (t) { for (var i = 0; i < p.length; i++) { if (p[i].type === t) return p[i].value; } return ''; };
      return { mins: (+g('hour')) * 60 + (+g('minute')), sec: +g('second'), wd: (g('weekday') || '').replace('.', '') };
    } catch (e) { var d = new Date(); return { mins: d.getHours() * 60 + d.getMinutes(), sec: d.getSeconds(), wd: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][d.getDay()] }; }
  }
  function expressLine() {
    var t = torontoNow(), c = cutoffs();
    if (t.wd === 'Sun') return 'For tomorrow (Monday) — no same-day Sundays';
    if (t.mins * 60 + t.sec < c.dc * 60) {
      var left = c.dc * 60 - (t.mins * 60 + t.sec);
      return 'Same-day: order in ' + Math.floor(left / 3600) + 'h ' + pad(Math.floor(left % 3600 / 60)) + 'm — tonight ' + eveLabel();
    }
    if (t.mins < c.pc) return 'Pickup today until 4 PM · delivery tomorrow';
    if (t.wd === 'Sat' && t.mins >= c.ro) return 'Next available: Monday'; // 周六晚 Express 全关(stepper 规则)
    return 'Order now for tomorrow';
  }
  // 手机首屏急单行(细调②):截单前倒计时 + 今晚;过了截单 = 明天;周六 17:00 后 = 周一(周日 Express 整体关闭,stepper 规则)
  function expressCta() {
    var t = torontoNow(), c = cutoffs();
    if (t.wd !== 'Sun' && t.mins * 60 + t.sec < c.dc * 60) {
      var left = c.dc * 60 - (t.mins * 60 + t.sec);
      return 'Order in ' + Math.floor(left / 3600) + 'h ' + pad(Math.floor(left % 3600 / 60)) + 'm → tonight ' + eveLabel();
    }
    if (t.wd === 'Sat' && t.mins >= c.ro) return 'Order now → Monday ' + eveLabel();
    return 'Order now → tomorrow ' + eveLabel();
  }
  // 首页重排(店主 10/10,TP-SYNC-20261010-HOME-DELIVERY-01):提前订为主、当天送兜底。手机首屏一行里急单只占右半边 → 短句
  // 截单前「Tonight? 4h 12m」,过了截单「Tomorrow? Order now」,周六 17:00 后「Monday? Order now」;规则同 expressCta。
  function expressShort() {
    var t = torontoNow(), c = cutoffs();
    if (t.wd !== 'Sun' && t.mins * 60 + t.sec < c.dc * 60) {
      var left = c.dc * 60 - (t.mins * 60 + t.sec);
      return { when: 'Tonight?', rest: Math.floor(left / 3600) + 'h ' + pad(Math.floor(left % 3600 / 60)) + 'm', tonight: true };
    }
    if (t.wd === 'Sat' && t.mins >= c.ro) return { when: 'Monday?', rest: 'Order now', tonight: false };
    return { when: 'Tomorrow?', rest: 'Order now', tonight: false };
  }
  function advanceLine() {
    try {
      var d2 = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Toronto', weekday: 'short', month: 'short', day: 'numeric' }).format(new Date(Date.now() + 172800000));
      return 'Any date from ' + d2 + ' · up to 180 days';
    } catch (e) { return 'Any date from the day after tomorrow · up to 180 days'; }
  }
  var bound = [];
  function render() {
    bound.forEach(function (b) {
      if (b.kind === 'express-cta') {
        var cta = expressCta();
        if (b.last !== cta) {
          b.last = cta;
          var k = cta.indexOf(' → ');
          b.el.textContent = '';
          var bb = document.createElement('b'); bb.textContent = cta.slice(0, k);
          b.el.appendChild(bb); b.el.appendChild(document.createTextNode(cta.slice(k)));
        }
        return;
      }
      if (b.kind === 'express-short') {
        var es = expressShort(), key = es.when + es.rest;
        if (b.last !== key) {
          b.last = key;
          b.el.textContent = '';
          var eb = document.createElement('b'); eb.textContent = es.when;
          b.el.appendChild(eb); b.el.appendChild(document.createTextNode(' ' + es.rest));
        }
        return;
      }
      var txt = b.kind === 'express' ? expressLine() : advanceLine();
      if (b.el.textContent !== txt) b.el.textContent = txt;
    });
  }
  function bind(el, kind) { if (!el || !kind) return; bound.push({ el: el, kind: kind }); render(); }
  function bindAll() {
    document.querySelectorAll('[data-tp-pool-line]').forEach(function (el) {
      if (el._tpPoolBound) return; el._tpPoolBound = true;
      bind(el, el.getAttribute('data-tp-pool-line'));
    });
  }
  setInterval(render, 1000);
  window.TPPoolPromise = { expressLine: expressLine, expressCta: expressCta, expressShort: expressShort, advanceLine: advanceLine, bind: bind, bindAll: bindAll };
  if (document.readyState !== 'loading') bindAll();
  else document.addEventListener('DOMContentLoaded', bindAll);
})();
